
const viewResultsSettings = {
    error: {
        hide: true,
    },
    minorError: {
        hide: true,
    },
    customStatus: {
        hide: true
    },
    timePoint: {
        disabled: true,
        hideEmpty: true
    },
    end: {
        disabled: true,
        hideEmpty: true,
        hide: true,
    },
    removed: {
        hide: true,
    },
    marker: {
        hide: true
    }
}

const colorSettings = {
    error: "red",
    customStatus: "yellow",
    timePoint: "primary",
    end: "rating1",
    endTranscription: "purple",
    minorError: "rating4",
    removed: "dark"
}

export { viewResultsSettings, colorSettings }